import clsx from 'clsx';
import StorageProviderDetails from 'components/Common/StorageProviderDetails/StorageProviderDetails';
import { useMergedStyles } from 'hooks/useMergedStyles';
import { FC, useCallback } from 'react';
import { StorageProviderDetailsInfoType } from 'types/storageProvider';
import { Styles } from 'types/styles';
import { AlgoliaSearchStorageProviderHit } from 'types/algolia';
import { isStorageProviderActive } from './StorageProviderItem.util';
import StorageProviderItemMainStats from './StorageProviderItemMainStats/StorageProviderItemMainStats';
import StorageProviderItemSecondaryStats from './StorageProviderItemSecondaryStats/StorageProviderItemSecondaryStats';

import styles from './StorageProviderItem.module.scss';

type Props = {
  storageProvider: AlgoliaSearchStorageProviderHit;
  handleClick: () => void;
  additionalClass?: string;
  clickable?: boolean;
  clickDisabled?: boolean;
  newStyles?: Styles;
};

const StorageProviderItem: FC<Props> = ({
  newStyles = {},
  storageProvider,
  clickable = true,
  clickDisabled = false,
  handleClick,
  additionalClass = '',
}) => {
  const mergedStyles = useMergedStyles(styles, newStyles);

  const handleClickCallback = useCallback(() => {
    if (!clickDisabled && clickable) handleClick();
  }, [clickDisabled, clickable, handleClick]);

  const isActive = isStorageProviderActive(storageProvider);

  return (
    <div
      className={clsx(mergedStyles['storage-provider-item-wrapper'], {
        [mergedStyles.clickable]: clickable,
        [mergedStyles['click-disabled']]: clickDisabled,
        [additionalClass]: additionalClass,
      })}
      data-cy="storage-provider"
      onClick={handleClickCallback}
    >
      <StorageProviderDetails
        data={{
          infoType: StorageProviderDetailsInfoType.ReviewFiveStars,
          storageProvider,
        }}
        newStyles={mergedStyles}
        gettingStorageProvider={false}
        isActive={isActive}
        hideLabelBox
      />

      <StorageProviderItemMainStats
        storagePower={storageProvider.storagePower}
        numberOfDeals={storageProvider.dealCount}
        isActive={isActive}
        newStyles={mergedStyles}
      />

      <StorageProviderItemSecondaryStats
        newStyles={mergedStyles}
        dataCenterCount={storageProvider.dataCenterCount}
        country={storageProvider.country}
      />
    </div>
  );
};

export default StorageProviderItem;
